import React, { useState, useEffect } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar, } from 'recharts';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import * as Constants from "./Constants/index";
import swal from 'sweetalert';
import TotalRegistrations from "../assets/New_Img/png total.png"

// --- IMPORT YOUR SIDEBAR ---
import Sidebar from './common/Sidebar';
import { Doughnut } from 'react-chartjs-2';
import DonutChart from './DonutChart';
import registred from '../assets/img/icons/totalregistration.png'
import approved from '../assets/img/icons/tickkk.png'
import reject from '../assets/img/icons/crossss.png'
import pending_approve from '../assets/img/icons/regby sales.png'
import active_plumber from '../assets/img/icons/Total Active Retailers.png'
import inactive_plumber from '../assets/img/icons/Total Inactive Retailers.png'
import scanned_qrcode from '../assets/img/icons/total_scaned.png'
import rejected_scan from '../assets/img/total_rejected.png'
import total_star from '../assets/img/icons/totalpointsallocated.png'
import redeemstar from '../assets/img/icons/redeemstar.png'
import pendingVerify from '../assets/img/icons/Pending Verification.png'
import reedemablePoints from '../assets/img/icons/redeemables.png'
import pendingReedemablePoints from '../assets/img/icons/pendingRedempotions.png'
import redeemPointBox from '../assets/img/icons/redeemPointBox.png'
import successScan from '../assets/img/icons/successScan.png'
import pendingforappoval from '../assets/img/icons/pendingForApproval.png'
import pendingforverification from '../assets/img/icons/pendingForVerification.png'
import approvalForUser from '../assets/img/icons/approval.png'


// --- STATIC CHART DATA (Scans & Approvals) ---
const chartData = [
    { name: 'Jan', Scans: 20000, Approvals: 15000 },
    { name: 'Feb', Scans: 28000, Approvals: 22000 },
    { name: 'Mar', Scans: 32000, Approvals: 25000 },
    { name: 'Apr', Scans: 45000, Approvals: 38000 },
    { name: 'May', Scans: 52000, Approvals: 41000 },
    { name: 'Jun', Scans: 75000, Approvals: 58000 },
];

// --- STATIC PIE DATA (Specific to Image) ---
// Dark Green = Active, Light Green = Inactive
const staticPieData = [
    { name: 'Active', value: 4171 },
    { name: 'Inactive', value: 12603 },
];

// --- COLORS ---
const COLORS = {
    activeGreen: '#4E7C48',   // Darker green for Active segment
    inactiveGreen: '#C8E6C9', // Light pale green for Inactive segment
    textDark: '#212529',
    textMuted: '#6c757d',
    iconGreen: '#4E7C48'
};

const New_Sales_Dashboard = () => {
    const [dashboard, setDashboard] = useState({});
    const [topRetailers, setTopRetailers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [barData, setBarData] = useState([]);

    // --- API CALLS ---
    // useEffect(() => {
    //     const token = localStorage.getItem('token');
    //     const language = localStorage.getItem('language') || 'en';
    //     const headers = {
    //         Authorization: `Bearer ${token}`,
    //         "Accept-Language": language,
    //         platform: Constants.pt || 'website',
    //         appVersion: Constants.av || '1.0',
    //         program: Constants.program || '1',
    //         company: Constants.company || '1',
    //     };

    //     const fetchData = async () => {
    //         setLoading(true);
    //         try {
    //             const resTop = await axios.get(Constants.baseUrl + "reports/top10Retailer/list?sortBy=totalPoints&sortAsc=true&limit=10&page=1", { headers });
    //             if (resTop.status === 201 && resTop.data.output) {
    //                 setTopRetailers(resTop.data.output.results || []);
    //             }

    //             const resDash = await axios.get(Constants.baseUrl + 'program/dashboard/sales', { headers });
    //             if (resDash.status === 201 && resDash.data.output) {
    //                 setDashboard(resDash.data.output || {});
    //             }

    //             const GraphBarData = await axios.post(Constants.baseUrl + "capture/qr/product_report_trend", {}, { headers });
    //             if (GraphBarData.status === 201 && GraphBarData.data.output) {
    //                 const formattedData = GraphBarData.data.output
    //                     .filter(item => item.category !== null) // remove null category
    //                     .map(item => ({
    //                         category: item.category,      // SAME AS JSON
    //                         total_scan: item.total_scan   // SAME AS JSON
    //                     }));

    //                 setBarData(formattedData);
    //             }

    //         } catch (err) {
    //             console.log('Error fetching data', err);
    //         }
    //         setLoading(false);
    //     };

    //     fetchData();
    // }, []);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const language = localStorage.getItem('language') || 'en';
        const headers = {
            Authorization: `Bearer ${token}`,
            "Accept-Language": language,
            platform: Constants.pt || 'website',
            appVersion: Constants.av || '1.0',
            program: Constants.program || '1',
            company: Constants.company || '1',
        };

        // 1. Fetch Top Retailers
        const fetchTopRetailers = async () => {
            try {
                const res = await axios.get(`${Constants.baseUrl}reports/top10Retailer/list?sortBy=totalPoints&sortAsc=true&limit=10&page=1`, { headers });
                if (res.status === 201 && res.data.output) {
                    setTopRetailers(res.data.output.results || []);
                }
            } catch (err) {
                console.error('Error fetching Top Retailers:', err);
            }
        };

        // 2. Fetch Dashboard Stats
        const fetchDashboardStats = async () => {
            try {
                const res = await axios.get(`${Constants.baseUrl}program/dashboard/sales`, { headers });
                if (res.status === 201 && res.data.output) {
                    setDashboard(res.data.output || {});
                }
            } catch (err) {
                console.error('Error fetching Dashboard Stats:', err);
            }
        };

        // 3. Fetch Graph/Bar Data
        const fetchGraphData = async () => {
            try {
                const res = await axios.post(`${Constants.baseUrl}capture/qr/product_report_trend`, {}, { headers });
                if (res.status === 201 && res.data.output) {
                    const formattedData = res.data.output
                        .filter(item => item.category !== null)
                        .map(item => ({
                            category: item.category,
                            total_scan: item.total_scan
                        }));
                    setBarData(formattedData);
                }
            } catch (err) {
                console.error('Error fetching Graph Data:', err);
            }
        };

        const loadAllData = async () => {
            setLoading(true);
            // Using Promise.allSettled so that if one API fails, the others still load
            await Promise.allSettled([
                fetchTopRetailers(),
                fetchDashboardStats(),
                fetchGraphData()
            ]);
            setLoading(false);
        };

        loadAllData();
    }, []);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="spinner-border text-success" role="status"><span className="visually-hidden">Loading...</span></div>
            </div>
        );
    }

    const handleLogout = () => {
        swal({
            title: "Are you sure?",
            text: "Do you really want to logout?",
            icon: "warning",
            buttons: ["Cancel", "Yes, Logout"],
            dangerMode: true,
        })
            .then((willLogout) => {
                if (willLogout) {
                    // 1. Clear Local Storage
                    localStorage.clear();
                    // 2. Redirect to Login Page
                    window.location.href = "/";
                }
            });
    };

    const BAR_WIDTH = 50;        // width per bar
    const MIN_WIDTH = 700;      // minimum chart width
    const MAX_WIDTH = 1200;     // maximum chart width

    const chartWidth = Math.min(
        Math.max(barData.length * BAR_WIDTH, MIN_WIDTH),
        MAX_WIDTH
    );

    const successfulScans =
        (dashboard?.scanTotal || 0) + (dashboard?.scanRejected || 0);

    return (
        <div className="d-flex" style={{ backgroundColor: '#F5F7FA', minHeight: '100vh', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>

            {/* --- SIDEBAR --- */}
            <Sidebar />

            {/* --- MAIN CONTENT --- */}
            <div className="flex-grow-1 p-4">

                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h2 className="fw-bold mb-0 text-dark">Dashboard</h2>
                        <p className="text-muted small mb-0">Here's a complete overview of the JK Seeds retailer program activities.</p>
                    </div>

                    <div className="d-flex align-items-center gap-3">

                        {/* Profile Info */}
                        <div className="d-flex align-items-center">
                            <div className="text-end me-2 lh-1">
                                <div className="fw-bold small">{localStorage.getItem("user_name")}</div>
                            </div>
                        </div>

                        {/* LOGOUT BUTTON */}
                        <button
                            className="btn btn-outline-danger btn-sm d-flex align-items-center gap-2"
                            onClick={handleLogout}
                            style={{ borderRadius: '8px', }}
                        >
                            <i className="bi bi-power"></i> Logout
                        </button>

                    </div>
                </div>

                {/* --- KPI CARDS ROW --- */}
                <div className="row g-3 mb-5">
                    <KpiCard title="Total Registrations" value={dashboard.members ? dashboard.members.toLocaleString() : "0"} imgIcon={registred} color="text-secondary" />
                    <KpiCard title="Reg. by MDO/TM" value={dashboard.newSales ? dashboard.newSales.toLocaleString() : "0"} imgIcon={pending_approve} color="text-secondary" />
                    <KpiCard title="Total Code Scans" value={(Number(dashboard?.scanTotal) || 0) + (Number(dashboard?.scanRejected) || 0)} imgIcon={scanned_qrcode} icon="bi-qr-code" color="text-success" />
                    <KpiCard title="Successful Scans" value={dashboard.scanTotal ? dashboard.scanTotal.toLocaleString() : "0"} imgIcon={successScan} icon="bi-qr-code-scan" color="text-success" />
                    <KpiCard title="Total Points Allocated" value={dashboard.pointsGiven ? dashboard.pointsGiven.toLocaleString() : "0"} imgIcon={total_star} icon="bi-star-fill" color="text-success" isStar={true} />
                </div>

                {/* --- MIDDLE ROW (Charts) --- */}
                <div className="row g-3 mb-4">

                    {/* --- SCANS & APPROVALS CHART --- */}
                    <div className="col-lg-8">
                        <div className="card border-0 shadow-sm h-100 rounded-4 overflow-hidden">
                            <div className="card-body p-4">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="fw-bold text-dark m-0" style={{ fontSize: '1.25rem' }}>Product Category Performance
                                    </h5>
                                    <div className="dropdown">
                                        <button className="btn btn-light btn-sm border rounded-pill px-3 text-muted" style={{ fontSize: '0.8rem' }}>
                                            {/* 01/01/2024 - 04/25/2024 <i className="bi bi-chevron-down ms-1"></i> */}
                                        </button>
                                    </div>
                                </div>

                                <div className="d-flex gap-4 mb-3">
                                    <div className="d-flex align-items-center">
                                        <span className="rounded-circle me-2" style={{ width: 12, height: 12, backgroundColor: '#89B449' }}></span>
                                        <span className="text-muted small fw-bold">Quantity</span>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: '100%',
                                        overflowX: 'auto',
                                        overflowY: 'hidden'
                                    }}
                                >
                                    <div
                                        style={{
                                            width: chartWidth,
                                            height: 300
                                        }}
                                    >
                                        <ResponsiveContainer width="100%" height="100%">
                                            <BarChart
                                                data={barData}
                                                margin={{
                                                    top: 10,
                                                    right: 20,
                                                    left: 0,
                                                    bottom: 45   // 👈 EXTRA SPACE FOR LABELS
                                                }}
                                                barCategoryGap={30}   // 👈 CATEGORY SPACING
                                            >
                                                <CartesianGrid vertical={false} stroke="#EAEAEA" />

                                                <XAxis
                                                    dataKey="category"
                                                    angle={-45}                 // 👈 45° tilt
                                                    textAnchor="end"
                                                    interval={0}
                                                    height={5}                 // 👈 space for rotated text
                                                    tick={{ fontSize: 11, fill: '#6B7280' }}
                                                    tickMargin={10}
                                                />

                                                <YAxis />

                                                <Tooltip formatter={(value) => [`${value}`, 'Quantity']} />

                                                <Bar
                                                    dataKey="total_scan"
                                                    fill="#43861a"
                                                    barSize={18}        // 👈 ab ye kaam karega
                                                    radius={[6, 6, 0, 0]}
                                                />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>

                                {/* Bottom Summary Bar from Image */}
                                {/* <div className="row mt-4 pt-3 border-top">
                                    <div className="col-6 d-flex align-items-center border-end">
                                        <div className="bg-success-subtle p-2 rounded-circle me-3">
                                            <i className="bi bi-check-circle-fill text-success fs-5"></i>
                                        </div>
                                        <div>
                                            <div className="text-muted small fw-bold">Approved</div>
                                            <div className="fw-bold fs-4 text-dark">{dashboard.memberApproved}</div>
                                        </div>
                                    </div>
                                    <div className="col-6 d-flex align-items-center ps-4">
                                        <div className="bg-danger-subtle p-2 rounded-circle me-3">
                                            <i className="bi bi-x-circle-fill text-danger fs-5"></i>
                                        </div>
                                        <div>
                                            <div className="text-muted small fw-bold">Rejected</div>
                                            <div className="fw-bold fs-4 text-dark">{dashboard.memberRejected}</div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>

                    {/* --- RETAILER STATUS CARD (MATCHING SEET.JPEG EXACTLY) --- */}
                    <div className="col-lg-4">
                        <div className="card border-0 shadow-sm h-80 rounded-3">
                            <div className="card-body p-4">
                                <h5 className="card-title fw-bold mb-4">Retailer Status</h5>

                                <div className="row align-items-center">

                                    {/* Donut Chart Section */}
                                    <div className="col-6 position-relative p-0">
                                        <div style={{ width: '100%', height: 260 }}>
                                            <DonutChart
                                                active={dashboard.memberActive}
                                                inactive={dashboard.memberInActive}
                                            />

                                            {/* Center Percentage */}
                                            <div
                                                className="position-absolute top-50 start-50 translate-middle text-center "
                                                style={{ pointerEvents: 'none' }}
                                            >

                                                <div className="d-flex justify-content-center gap-4 mt-1 small">
                                                    <div className="d-flex align-items-center gap-1">
                                                        <span
                                                            style={{
                                                                width: 10,
                                                                height: 10,
                                                                background: "#43861A",
                                                                borderRadius: "50%",
                                                                display: "inline-block"
                                                            }}
                                                        />
                                                        <span>
                                                            {/* Active{" "} */}
                                                            <strong>
                                                                {dashboard.members
                                                                    ? Math.round((dashboard.memberActive / dashboard.members) * 100)
                                                                    : 0}%
                                                            </strong>
                                                        </span>
                                                    </div>

                                                    <div className="d-flex align-items-center gap-1">
                                                        <span
                                                            style={{
                                                                width: 10,
                                                                height: 10,
                                                                background: "#E2EDAB",
                                                                borderRadius: "50%",
                                                                display: "inline-block"
                                                            }}
                                                        />
                                                        <span>
                                                            {/* Inactive{" "} */}
                                                            <strong>
                                                                {dashboard.members
                                                                    ? Math.round((dashboard.memberInActive / dashboard.members) * 100)
                                                                    : 0}%
                                                            </strong>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* ✅ Bottom Percentages */}
                                    </div>

                                    {/* Right Info Section */}
                                    <div className="col-6 ps-2">
                                        {/* Active / Inactive Text */}
                                        <div className="mb-2" style={{ fontSize: "14px" }}>
                                            <span className="text-muted small">Active: </span>
                                            <span className="fw-bold text-dark">{dashboard.memberActive}</span>
                                        </div>
                                        <div className="mb-3" style={{ fontSize: "14px" }}>
                                            <span className="text-muted small">Inactive: </span>
                                            <span className="fw-bold text-dark">{dashboard.memberInActive}</span>
                                        </div>

                                        {/* Grey Bordered Box */}
                                        <div className="border rounded p-2 bg-white mt-3">
                                            <div className="d-flex flex-column">
                                                {/* Left side of box: Pending */}
                                                <div className="d-flex  justify-content-between" style={{ width: '100%' }}>
                                                    <div>
                                                        <div className="d-flex align-items-center mb-1">
                                                            <i className="bi bi-list-ul me-2 text-dark"></i>
                                                            <span className="fw-bold text-dark">{dashboard.pendingverification}</span>
                                                        </div>
                                                        <div className="text-muted lh-1" style={{ fontSize: '9px', fontWeight: 500 }}>
                                                            Pending<br />Verification
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <img src={pendingforverification} style={{ height: "45px" }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="border rounded p-2 bg-white mt-3">
                                            <div className="d-flex flex-column">
                                                {/* Left side of box: Pending */}
                                                <div className="d-flex  justify-content-between" style={{ width: '100%' }}>
                                                    <div>
                                                        <div className="d-flex align-items-center mb-1">
                                                            <i className="bi bi-list-ul me-2 text-dark"></i>
                                                            <span className="fw-bold text-dark">{dashboard.memberVerified}</span>
                                                        </div>
                                                        <div className="text-muted lh-1" style={{ fontSize: '9px', fontWeight: 500 }}>
                                                            Pending<br />For Approval
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <img src={pendingforappoval} style={{ height: "45px" }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Footer Icons (Green Check & Recycle/Leaf) */}
                                <div className="d-flex justify-content-between pt-3 border-top mt-4">
                                    <div className="d-flex align-items-center gap-2 flex-column">
                                        {/* Face/Check Icon */}
                                        <div className=" d-flex align-items-center justify-content-center">
                                            <div className=" d-flex align-items-center justify-content-center">
                                                {/* <i className="bi bi-emoji-smile text-success" style={{ fontSize: '14px' }}></i> */}
                                                <img src={approved} style={{ height: "35px" }} />
                                            </div>
                                            <br />
                                            <span className="fw-bold fs-5 text-dark">{dashboard.memberApproved}</span>

                                        </div>
                                        <p style={{ fontSize: "12px" }}>Approved</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 flex-column">
                                        {/* Face/Check Icon */}
                                        <div className=" d-flex align-items-center justify-content-center">
                                            <div className=" d-flex align-items-center justify-content-center">
                                                {/* <i className="bi bi-emoji-smile text-success" style={{ fontSize: '14px' }}></i> */}
                                                <img src={reject} style={{ height: "35px" }} />
                                            </div>
                                            <br />
                                            <span className="fw-bold fs-5 text-dark">{dashboard.memberRejected}</span>

                                        </div>
                                        <p style={{ fontSize: "12px" }}>Reject</p>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                {/* --- BOTTOM ROW (Tables & Summary) --- */}
                <div className="row g-3">
                    <div className="col-lg-8">
                        <div className="card border-0 shadow-sm rounded-3 h-100">
                            <div className="card-header bg-white border-0 pt-3 pb-0 d-flex justify-content-between align-items-center">
                                <h5 className="fw-bold mb-0">Top 10 Retailers</h5>
                                <div className="d-flex align-items-center gap-2">
                                    <i className="bi bi-list fs-5 text-muted cursor-pointer"></i>
                                    <i className="bi bi-plus fs-5 text-primary cursor-pointer"></i>
                                </div>
                            </div>
                            <div className="card-body">
                                <table className="table align-middle mb-0" style={{ fontSize: '0.95rem' }}>
                                    <thead className="text-muted small">
                                        <tr>
                                            <th className="ps-3 border-0 fw-normal">S.no.</th>
                                            <th className="border-0 fw-normal">Name</th>
                                            <th className="text-end border-0 fw-normal">Mobile</th>
                                            <th className="text-end pe-3 border-0 fw-normal">Points</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {topRetailers.length > 0 ? (
                                            topRetailers.map((item, idx) => (
                                                <tr key={idx} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                    <td className="ps-3 border-0 text-muted">{idx + 1}</td>
                                                    <td className="border-0 fw-semibold text-dark">{item[0]}</td>
                                                    <td className="text-end border-0 text-muted">{item[1]}</td>
                                                    <td className="text-end pe-3 border-0 fw-bold text-dark">{item[29]}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" className="text-center py-4 text-muted">No retailers found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className="card border-0 shadow-sm rounded-3 h-100">
                            <div className="card-body p-4">
                                <h5 className="fw-bold mb-4">Redemption Summary</h5>
                                <div className="mb-4 border-bottom pb-3 d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <div className="bg-white p-1 rounded shadow-sm me-3 text-success">
                                            {/* <i className="bi bi-gift-fill fs-4"></i> */}
                                            <img src={reedemablePoints} style={{ height: "45px" }} />
                                        </div>
                                        <div>
                                            <h6 className="mb-0 fw-bold text-dark">Total Redeemable Points</h6>
                                            {/* <small className="text-muted">Available balance</small> */}
                                        </div>
                                    </div>
                                    <div className="fw-bold fs-4 text-dark">{dashboard.pointsRedeemable}</div>
                                </div>
                                <div className="mb-4 border-bottom pb-3 d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <div className="bg-white p-1 rounded shadow-sm me-3 text-success">
                                            <img src={redeemPointBox} style={{ height: "45px" }} />
                                            {/* <i className="bi bi-hourglass-split fs-4"></i> */}
                                        </div>
                                        <div>
                                            <h6 className="mb-0 fw-bold text-dark">Redeemed Points</h6>
                                            {/* <small className="text-muted">Lifetime redeemed</small> */}
                                        </div>
                                    </div>
                                    <div className="fw-bold fs-4 text-dark">{dashboard.pointsRedeemed}</div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <div className="bg-white p-1 rounded shadow-sm me-3 text-warning">

                                            <img src={pendingReedemablePoints} style={{ height: "45px" }} />
                                        </div>
                                        <div>
                                            <h6 className="mb-0 fw-bold text-dark">Pending Redeemable Points</h6>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="fw-bold fs-4 me-2 text-dark">{dashboard.pendingRedeemption}</div>
                                        {/* <span className="badge bg-white text-muted border shadow-sm px-2">-- 3</span> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// --- Helper Component for Top Cards ---
const KpiCard = ({ title, value, sub, icon, color, isStar, imgIcon }) => (
    <div className="sale-box-dash">
        <div className="card border-0 shadow-sm h-100 rounded-3">
            <div className="card-body d-flex align-items-start p-3">
                <div className={`me-3 fs-2 ${color}`}>
                    <img src={imgIcon} style={{ height: "50px" }} />
                    {/* {isStar ? <i className="bi bi-star-fill text-success"></i> : <i className={`bi ${icon}`}></i>} */}
                </div>
                <div>
                    <div className="text-muted mb-1" style={{ fontWeight: "bold", fontSize: "12px" }}>{title}</div>
                    <div className="fw-bold fs-3 text-dark d-flex align-items-center">
                        {value}
                        {sub && <span className="ms-2 badge bg-light text-success border border-success rounded-pill" style={{ fontSize: '10px', padding: '4px 6px' }}>{sub}</span>}
                    </div>
                </div>
            </div>
        </div>
    </div>
);


const formatLabel = (value) => {
    if (!value) return '';
    return value.split(' ');
};

const CustomXAxisTick = ({ x, y, payload }) => {
    const words = payload.value?.split(" ") || [];

    return (
        <g transform={`translate(${x}, ${y + 20})`}> {/* 👈 PUSH DOWN */}
            <text
                textAnchor="middle"
                fill="#666"
                fontSize={11}
            >
                {words.map((word, index) => (
                    <tspan
                        key={index}
                        x="0"
                        dy={index === 0 ? 0 : 14}   // 👈 line spacing
                    >
                        {word}
                    </tspan>
                ))}
            </text>
        </g>
    );
};

export default New_Sales_Dashboard;
